import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=1fcbe33e&scoped=true"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"
import style0 from "./Person.vue?vue&type=style&index=0&id=1fcbe33e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcbe33e",
  null
  
)

export default component.exports